import { useEffect, useMemo, useState } from 'react';
import { fetchZones, ZoneCatalogItem } from '../api/publicationCatalogs';

export interface ZoneFilterOption {
  id: string;
  name: string;
}

interface UsePublicationZonesParams {
  marketplace: string;
}

export const usePublicationZones = ({ marketplace }: UsePublicationZonesParams) => {
  const [zones, setZones] = useState<ZoneCatalogItem[]>([]);
  const [loadingZones, setLoadingZones] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const loadZones = async () => {
      setLoadingZones(true);
      try {
        const zonesData = await fetchZones(marketplace);
        if (!cancelled) setZones(zonesData);
      } catch {
        if (!cancelled) setZones([]);
      } finally {
        if (!cancelled) setLoadingZones(false);
      }
    };

    loadZones();

    return () => {
      cancelled = true;
    };
  }, [marketplace]);

  const zoneOptions = useMemo<ZoneFilterOption[]>(
    () => [
      { id: '', name: 'Todas las zonas' },
      ...zones.map((zone) => ({
        id: zone.zone_id,
        name: zone.name,
      })),
    ],
    [zones],
  );

  return {
    zoneOptions,
    loadingZones,
  };
};
